import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import SectionBody from "../../components/structure/SectionBody";
import Button from "../../components/singlecomponents/Button";
import "../../stylesheet/pages/NoMatch.scss";

const NoMatch: React.FC = () => {
  const { t, i18n, ready } = useTranslation();
  return (
    <div className="main">
      <SectionBody>
        <div className="nomatch__wrapper">
          <div className="nomatch__container">
            <h1>404</h1>
            <p>
              <b>{ready ? `${t("page404.content")}` : <Skeleton />}</b>
            </p>
            <Link to={`/${i18n.language}`}>
              <Button name={t("button.go-home")} />
            </Link>
          </div>
        </div>
      </SectionBody>
    </div>
  );
};

export default NoMatch;
